import React from 'react';

import { RadioCardOption } from './radio-card-option';

interface RadioCardOptionGroupProps {
  options: Array<{
    id: string;
    label: string;
    description: string;
    name: string;
    icon?: string;
  }>;
}

export function RadioCardOptionGroup({ options }: RadioCardOptionGroupProps) {
  return (
    <div className="radio-card-button-group">
      {options.map((option) => (
        <RadioCardOption
          key={option.id}
          id={option.id}
          label={option.label}
          description={option.description}
          name={option.name}
          value={option.id}
          icon={option.icon}
        />
      ))}
    </div>
  );
}
